/**
 * Mask bearer presentation URLs for visible/accessibility text only.
 * Copy / share / QR / public href must keep the canonical URL.
 */
export function maskPresentationPublicUrl(url) {
  if (!url) return "";
  const raw = String(url);
  try {
    const parsed = new URL(raw);
    const match = parsed.pathname.match(/^(\/p\/)/i);
    if (match) {
      return `${parsed.origin}${match[1]}••••••••`;
    }
  } catch (_err) {
    /* fall through */
  }
  return raw.replace(/(\/p\/)[^/?#]+/i, "$1••••••••");
}
